import './styles/index.scss';
import 'element-plus/dist/index.css'
// v-loading指令样式
import 'element-plus/theme-chalk/el-loading.css';

import * as ElementPlusIconsVue from '@element-plus/icons-vue';

import App from '@/App.vue';
import ElementPlus from 'element-plus'
import { createApp } from 'vue';
import router from './router';
import { setupStore } from '@/store';

const app = createApp(App);
// ElementPlus 已全局注册 v-loading 指令，无需重复注册
app.use(ElementPlus)
// 全局状态
setupStore(app);

// 全局注册所有 Element Plus 图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

app.use(router);
app.mount('#app');
